import { Metamodel } from '../base/model';
import { Named } from '../base/named';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ModelConstants } from '../../model/model-constants';

@Metamodel.model({
    name: ModelConstants.pbiNotebook,
    display: [shellStringResources.NotebookActivityLabel],
    reusable: true,
    referable: true
})
export class PbiNotebook extends Named {
    public workspaceId: string;
    public name: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
